module.exports = function() {
  return new Worker(__webpack_public_path__ + "a6528431f0d384b2b523.worker.js");
};